module.exports = __webpack_public_path__ + "img/Artwork@2x.04b72b70.png";